import React from 'react';
import { styled } from '@linaria/react';

interface Props extends React.HTMLAttributes<SVGElement> {
  width?: number;
  height?: number;
  pointing?: 'down' | 'up';
}

function Tip({
  width = 32,
  height = 12,
  pointing = 'up',
  style = {},
  ...delegated
}: Props) {
  const tipPointinessFactor = width * 0.2;

  const path =
    pointing === 'up'
      ? `
        M 0 ${height}
        C ${width * 0.25} ${height}
          ${width / 2 - tipPointinessFactor} 0
          ${width / 2} 0
        C ${width / 2 + tipPointinessFactor} 0
          ${width * 0.75} ${height}
          ${width} ${height}
        Z
      `
      : `
        M 0 0
        C ${width * 0.25} 0
          ${width / 2 - tipPointinessFactor} ${height}
          ${width / 2} ${height}
        C ${width / 2 + tipPointinessFactor} ${height}
          ${width * 0.75} 0
          ${width} 0
        Z
      `;

  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox={`0 0 ${width} ${height}`}
      style={{
        ...style,
        '--origin-y': pointing === 'up' ? '100%' : '0%',
      }}
      {...delegated}
    >
      <path d={path} />
    </Svg>
  );
}

const Svg = styled.svg`
  display: block;
  overflow: visible;
  transform-origin: 50% var(--origin-y);
  will-change: transform;

  @media (prefers-reduced-motion: no-preference) {
    animation: expand 500ms;
  }

  path {
    fill: currentColor;
    stroke: none;
  }

  @keyframes expand {
    /*
    HACK: If I start this from 0%, the end result is pixellated.
    Because the dropdown fades in, it doesn't matter if the tip is full-height for the first frame.

    I'm adding this 0% opacity so that there isn't even a slight flicker.
  */
    0% {
      opacity: 0.1;
    }

    1% {
      opacity: 1;
      transform: scaleY(0.2);
    }
  }
`;

export default Tip;
